import gql from 'graphql-tag'
import { transformObject } from '../common/helpers'

export const gqlExtrato = gql`
  query extrato(
    $idConta: String!
    $quantidade: Int
    $pagina: Int
    $placa: String
    $placas: [FiltroPlacas]
    $transacoes: [FiltroTransacoes]
    $periodo: String
    $diaDaSemana: String
    $startSqlDateFilter: String
    $endSqlDateFilter: String
    $valePedagio: String
    $portalParceiro: String
  ) {
    extrato(
      idConta: $idConta
      pagina: $pagina
      placa: $placa
      placas: $placas
      quantidade: $quantidade
      transacoes: $transacoes
      periodo: $periodo
      diaDaSemana: $diaDaSemana
      startSqlDateFilter: $startSqlDateFilter
      endSqlDateFilter: $endSqlDateFilter
      valePedagio: $valePedagio
      portalParceiro: $portalParceiro
    ) {
      transacoes {
        identificador
        veiculo {
          placa
        }
        endereco
        valor
        valePedagio
        vpVigenciaInicio
        vpVigenciaFim
        vpOrigem
        vpDestino
        vpIdveloe
        vpCnpjEmbarcador
        fastId
        cyberId
        estabelecimentoComercial {
          codigo
          nome
          tipoTransacao
        }
        clienteConta {
          cliente {
            id
          }
          conta {
            conta
          }
        }
        tipoMovimento
        dataProcessamento
        horaProcessamento
        dataEvento
        horaEvento
        dataFimEvento
        horaFimEvento
        motivoTransacao
        permanencia
      }
      enviarExtratoEmail
    }
  }
`

const mapExtrato = {
  'fast-id': 'fastId',
  'cyber-id': 'cyberId',
  'estabelecimento-comercial.nome': 'estabelecimentoComercial.nome',
  'estabelecimento-comercial.tipo-transacao': 'estabelecimentoComercial.tipoTransacao',
  'cliente-conta': 'clienteConta',
  'tipo-movimento': 'tipoMovimento',
  'data-processamento': 'dataProcessamento',
  'hora-processamento': 'horaProcessamento',
  'data-evento': 'dataEvento',
  'hora-evento': 'horaEvento',
  'data-fim-evento': 'dataFimEvento',
  'hora-fim-evento': 'horaFimEvento',
  'motivo-transacao': 'motivoTransacao'
  // TODO GraphQL não retorna info de eixo-cobrado
  // TODO GraphQL não retorna info de eixo-cadastrado
}

export const transformExtrato = src => {
  const { extrato } = src.data
  const { transacoes, enviarExtratoEmail } = extrato
  if (!transacoes) return []

  const newTransacoes = transacoes.map(t => ({
    ...t,
    ...transformObject(t, mapExtrato),
    valePedagio: Boolean(t.valePedagio),
    identificador: Number.parseInt(t.identificador, 10)
  }))

  return { transacoes: newTransacoes, enviarExtratoEmail }
}

export const gqlDownloadExtratoCsv = gql`
  query extratoCSV(
    $idConta: String!
    $pagina: Int
    $placa: String
    $placas: [FiltroPlacas]
    $quantidade: Int
    $transacoes: [FiltroTransacoes]
    $periodo: String
    $diaDaSemana: String
    $startSqlDateFilter: String
    $endSqlDateFilter: String
    $valePedagio: String
  ) {
    extratoCSV(
      idConta: $idConta
      pagina: $pagina
      placa: $placa
      placas: $placas
      quantidade: $quantidade
      transacoes: $transacoes
      periodo: $periodo
      diaDaSemana: $diaDaSemana
      startSqlDateFilter: $startSqlDateFilter
      endSqlDateFilter: $endSqlDateFilter
      valePedagio: $valePedagio
    ) {
      result
    }
  }
`

export const gqlDownloadExtratoPdf = gql`
  query download(
    $idConta: String!
    $pagina: Int
    $placa: String
    $quantidade: Int
    $placas: [FiltroPlacas]
    $transacoes: [FiltroTransacoes]
    $periodo: String
    $diaDaSemana: String
    $startSqlDateFilter: String
    $endSqlDateFilter: String
    $valePedagio: String
  ) {
    download(
      idConta: $idConta
      pagina: $pagina
      placa: $placa
      placas: $placas
      quantidade: $quantidade
      transacoes: $transacoes
      periodo: $periodo
      diaDaSemana: $diaDaSemana
      startSqlDateFilter: $startSqlDateFilter
      endSqlDateFilter: $endSqlDateFilter
      valePedagio: $valePedagio
    ) {
      result
    }
  }
`

export const gqlResendStatement = gql`
  mutation reenvioTransacaoPost($fastId: String!) {
    reenvioTransacaoPost(fastId: $fastId) {
      codigo
    }
  }
`

export const gqlSendStatementEmail = gql`
  query extratoEmail(
    $idConta: String!
    $email: String
    $formato: String
    $placa: String
    $placas: [FiltroPlacas]
    $transacoes: [FiltroTransacoes]
    $periodo: String
    $diaDaSemana: String
    $startSqlDateFilter: String
    $endSqlDateFilter: String
    $valePedagio: String
  ) {
    extratoEmail(
      idConta: $idConta
      email: $email
      placa: $placa
      placas: $placas
      transacoes: $transacoes
      formato: $formato
      periodo: $periodo
      diaDaSemana: $diaDaSemana
      startSqlDateFilter: $startSqlDateFilter
      endSqlDateFilter: $endSqlDateFilter
      valePedagio: $valePedagio
    ) {
      result
    }
  }
`

export const gqlListPlateFilters = gql`
  query listaFiltro($conta: String, $tipo: String) {
    listaFiltro(conta: $conta, tipo: $tipo) {
      id
      descricaoFiltro
      info {
        placa
      }
      tipo
    }
  }
`

export const gqlCreatePlateFilter = gql`
  mutation inserirFiltro($filtro: FiltroExtrato) {
    inserirFiltro(filtroExtrato: $filtro) {
      id
    }
  }
`

export const gqlUpdatePlateFilter = gql`
  mutation alterarFiltro($filtro: FiltroExtrato, $id: String) {
    alterarFiltro(filtroExtrato: $filtro, id: $id) {
      id
      descricaoFiltro
      info {
        placa
      }
      tipo
    }
  }
`

export const gqlDeletePlateFilter = gql`
  mutation deletarFiltro($conta: String, $id: String) {
    deletarFiltro(conta: $conta, id: $id) {
      msg
    }
  }
`



// WEBPACK FOOTER //
// ./src/alelo-logic/services/queries/transactions.js